import type { ZInfer, authSchemas } from 'types';
import { Api } from './fetch';

export class AuthNet {
  static password = {
    change: (body: ZInfer<typeof authSchemas.general.changePassword>) =>
      Api.post<'auth', 'changePassword'>('/auth/password/change', { body }),
    changeFlag: (body: ZInfer<typeof authSchemas.general.data.password>) =>
      Api.post<'auth', 'changePasswordFlag'>('/auth/password/change/flag', { body }),
    forgot: (email: string) => Api.get<'auth', 'forgot'>('/auth/password/forgot', { query: { email } }),
    reset: (body: ZInfer<typeof authSchemas.general.resetPassword>) =>
      Api.post<'auth', 'resetPassword'>('/auth/password/reset', { body }),
  };

  static email = {
    check: (email: string) => Api.get<'auth', 'emailExists'>('/auth/email/check', { query: { email } }),
    resendConfirmation: (email: string) =>
      Api.get<'auth', 'resendConfirmEmail'>('/auth/confirm/resend', { query: { email } }),
  };

  static auth = {
    register: (body: ZInfer<typeof authSchemas.general.register>) =>
      Api.post<'auth', 'register'>('/auth/register', { body }),
    login: (body: ZInfer<typeof authSchemas.general.login>) => Api.post<'auth', 'login'>('/auth/login', { body }),
    logout: () => Api.get<'auth', 'logout'>('/auth/logout'),
    logoutAll: () => Api.get<'auth', 'logoutAll'>('/auth/logout/all'),
  };

  static twoFA = {
    setupBackupCodes: () => Api.get<'auth', 'setupBackupCodes'>('/auth/2fa/codes/setup'),
    verifySetupBackupCodes: (body: ZInfer<typeof authSchemas.general.data.backupCodes2fa>) =>
      Api.post<'auth', 'verifySetupBackupCodes'>('/auth/2fa/codes/setup/verify', { body }),
    rotateBackupCodes: () => Api.get<'auth', 'rotateBackupCodes'>('/auth/2fa/codes/rotate'),

    setupTotp: () => Api.get<'auth', 'setupTotp'>('/auth/2fa/totp/setup'),
    changeTotp: () => Api.get<'auth', 'changeTotp'>('/auth/2fa/totp/setup/change'),
    verifySetupTotp: (body: ZInfer<typeof authSchemas.general.data.totp2fa>) =>
      Api.post<'auth', 'verifySetupTotp'>('/auth/2fa/totp/setup/verify', { body }),

    delete2fa: () => Api.delete<'auth', 'delete2fa'>('/auth/2fa'),
  };
}
